/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const cs_checkout_success_email = /** @type {(inputs: {}) => string} */ () => {
	return `Potvrzovací e-mail byl odeslán na vaši e-mailovou adresu.`
};

const da_checkout_success_email = /** @type {(inputs: {}) => string} */ () => {
	return `En bekræftelsesmail er sendt til din adresse.`
};

const de_checkout_success_email = /** @type {(inputs: {}) => string} */ () => {
	return `Eine Bestätigungs-E-Mail wurde an Ihre Adresse gesendet.`
};

const en_checkout_success_email = /** @type {(inputs: {}) => string} */ () => {
	return `A confirmation email has been sent to your address.`
};

const es_checkout_success_email = /** @type {(inputs: {}) => string} */ () => {
	return `Se ha enviado un correo de confirmación a tu dirección.`
};

const fr_checkout_success_email = /** @type {(inputs: {}) => string} */ () => {
	return `Un email de confirmation a été envoyé à votre adresse.`
};

const hu_checkout_success_email = /** @type {(inputs: {}) => string} */ () => {
	return `Megerősítő e-mail küldésre került az e-mail címedre.`
};

const it_checkout_success_email = /** @type {(inputs: {}) => string} */ () => {
	return `Una email di conferma è stata inviata al tuo indirizzo.`
};

const nl_checkout_success_email = /** @type {(inputs: {}) => string} */ () => {
	return `Een bevestigingsmail is verzonden naar je e-mailadres.`
};

const pl_checkout_success_email = /** @type {(inputs: {}) => string} */ () => {
	return `Potwierdzenie zostało wysłane na Twój adres e-mail.`
};

const pt_checkout_success_email = /** @type {(inputs: {}) => string} */ () => {
	return `Um e-mail de confirmação foi enviado para seu endereço.`
};

const sv_checkout_success_email = /** @type {(inputs: {}) => string} */ () => {
	return `En bekräftelse har skickats till din e-postadress.`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "cs" | "da" | "de" | "en" | "es" | "fr" | "hu" | "it" | "nl" | "pl" | "pt" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const checkout_success_email = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.checkout_success_email(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("checkout_success_email", locale)
	if (locale === "cs") return cs_checkout_success_email(inputs)
	if (locale === "da") return da_checkout_success_email(inputs)
	if (locale === "de") return de_checkout_success_email(inputs)
	if (locale === "en") return en_checkout_success_email(inputs)
	if (locale === "es") return es_checkout_success_email(inputs)
	if (locale === "fr") return fr_checkout_success_email(inputs)
	if (locale === "hu") return hu_checkout_success_email(inputs)
	if (locale === "it") return it_checkout_success_email(inputs)
	if (locale === "nl") return nl_checkout_success_email(inputs)
	if (locale === "pl") return pl_checkout_success_email(inputs)
	if (locale === "pt") return pt_checkout_success_email(inputs)
	return sv_checkout_success_email(inputs)
};
export { checkout_success_email as "checkout.success_email" }